import cx from 'classnames';
import React, { Children, useEffect, useState } from 'react';
import { BooleanField } from 'src/components/LandingPage/ServicePlans/components/BooleanField';
import { ServicePlansHeader } from 'src/components/LandingPage/ServicePlans/components/ServicePlansHeader';
import { StringField } from 'src/components/LandingPage/ServicePlans/components/StringField';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import * as classes from './ServicePlans.module.scss';
import { useWindowResize } from 'src/hooks/useWindowResize';

export const ServicePlans = ({ plans, features, _rawHeader }) => {
  const [currentPlanIndex, setCurrentPlanIndex] = useState(0);
  const [isMobileView, setIsMobileView] = useState(undefined);

  const highlightedPlanIndex = plans.findIndex((e) => e.highlighted);

  useWindowResize(() => {
    if (typeof window === 'undefined') return;
    setIsMobileView(window.innerWidth <= 991);
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    setIsMobileView(window.innerWidth <= 991);
  }, []);

  return isMobileView === undefined ? null : (
    <div>
      <PortableHeader className={classes.header} content={_rawHeader} />
      <table className={classes.table}>
        <ServicePlansHeader
          currentPlanIndex={currentPlanIndex}
          onPlanSelect={setCurrentPlanIndex}
          plans={plans}
          highlightedPlanIndex={highlightedPlanIndex}
          isMobileView={isMobileView}
        />
        <tbody>
          {Children.toArray(
            features.map((feature) => (
              <>
                <tr className={classes.featureRow}>
                  <td colSpan={isMobileView ? Math.floor(feature.feature.values.length / 2) + 1 : 1}>
                    <div className={classes.featureTitle}>{feature.feature.title}</div>
                    <div className={classes.featureDescription}>{feature.feature.description}</div>
                  </td>
                  {Children.toArray(
                    feature.feature.values.map((value, i) => {
                      const classNames = cx({
                        [classes.highlighted]: i === highlightedPlanIndex && !feature.subFeatures.length,
                        [classes.subFeature]: feature.subFeatures.length,
                        [classes.feature]: true,
                        [classes.currentFeature]: i === currentPlanIndex,
                      });

                      if (feature.feature.valueType === 'boolean')
                        return (
                          <BooleanField
                            value={value.value}
                            colSpan={isMobileView ? Math.floor(feature.feature.values.length / 2) : 1}
                            className={classNames}
                          />
                        );
                      if (feature.feature.valueType === 'string')
                        return (
                          <StringField
                            colSpan={isMobileView ? Math.floor(feature.feature.values.length / 2) : 1}
                            value={value.value}
                            description={value.description}
                            className={classNames}
                          />
                        );
                      return null;
                    })
                  )}
                </tr>
                {Children.toArray(
                  feature.subFeatures.length
                    ? feature.subFeatures.map((subFeature) => (
                        <tr>
                          <td colSpan={isMobileView ? Math.floor(subFeature.values.length / 2) + 1 : 1}>
                            <div className={classes.subFeatureTitle}>{subFeature.title}</div>
                            <div className={classes.subFeatureDescription}>{subFeature.description}</div>
                          </td>
                          {Children.toArray(
                            subFeature.values.map((value, i) => {
                              const classNames = cx({
                                [classes.subFeature]: true,
                                [classes.feature]: true,
                                [classes.currentFeature]: i === currentPlanIndex,
                              });

                              if (subFeature.valueType === 'boolean')
                                return (
                                  <BooleanField
                                    colSpan={isMobileView ? Math.floor(subFeature.values.length / 2) : 1}
                                    value={value.value}
                                    className={classNames}
                                  />
                                );
                              if (subFeature.valueType === 'string')
                                return (
                                  <StringField
                                    colSpan={isMobileView ? Math.floor(subFeature.values.length / 2) : 1}
                                    value={value.value}
                                    description={value.description}
                                    className={classNames}
                                  />
                                );
                              return null;
                            })
                          )}
                        </tr>
                      ))
                    : null
                )}
              </>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
